module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/enquiry-white-icon-0ba6b161e797003711541597ce7a0de0.png";